(() => {
  class StickyEngine extends HTMLElement {
    constructor() {
      super();
      this.padding = parseInt(this.dataset.padding, 10) || 0;
      this.stickyTopPart = document.getElementById('grid-archive-header');
      this.headerEl = document.getElementById('nav-wrapper');
      this.mainNav = document.querySelector('main-nav');
      this.headerType = this.mainNav?.dataset.uxPosition || 'off';
      this.headerHeight = this.headerEl?.offsetHeight || 0;
      this.updateDistance = this.updateDistance.bind(this);
    }

    connectedCallback() {
      this.lastScroll = window.scrollY;
      window.addEventListener('scroll', this.updateDistance);
    }

    updateDistance() {
      if (!window.matchMedia('screen and (min-width: 1024px)').matches) return;

      let offset = 0;
      if (this.stickyTopPart) {
        offset = this.stickyTopPart.clientHeight;
        if (this.headerType === 'fixed') offset += this.headerHeight;
      } else if (this.headerType === 'hide' && this.headerEl?.props) {
        offset = -this.headerEl.props.navMargin + this.headerHeight;
      } else if (this.headerType === 'fixed') {
        offset = this.headerHeight;
      }

      const maximumTop = offset + this.padding;
      if (this.scrollHeight < window.innerHeight - maximumTop) {
        this.style.top = `${maximumTop}px`;
      } else {
        const direction = window.scrollY - this.lastScroll;
        const nextTop = -direction + (parseInt(this.style.top, 10) || 0);
        if (direction > 0) {
          const minimumTop = window.innerHeight - this.scrollHeight - this.padding;
          if (minimumTop !== parseInt(this.style.top, 10)) {
            if (minimumTop <= nextTop) {
              this.style.top = `${nextTop}px`;
            } else if (nextTop + direction > minimumTop) {
              this.style.top = `${minimumTop}px`;
            }
          }
        } else {
          this.style.top = `${Math.min(nextTop, maximumTop)}px`;
        }
      }
      this.lastScroll = this.scrollPosition;
    }

    get scrollPosition() {
      return Math.max(0, Math.min(window.scrollY, document.body.offsetHeight - window.innerHeight));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateDistance);
    }
  }

  if (!window.customElements.get('sticky-engine')) window.customElements.define('sticky-engine', StickyEngine);
})();
